import Http from '../../../http';
import { SET_REFUNDS_AND_DISCOUNTS } from './constants';
import { SET_BARBER_FILTER } from '../metrics/constants';

const setItems = payload => ({
  type: SET_REFUNDS_AND_DISCOUNTS,
  payload,
});

export const fetchDiscountsBreakdownReport = (
  shopId,
  barberId,
  from,
  to,
  barberFilter,
  serviceCategories,
  productBrands,
  kind
) =>
  (dispatch) => {
    const filters = { barberId, barberFilter, serviceCategories, productBrands, type: kind };
    return Http.get(`/shop/${shopId}/report/discounted-breakdown/${from}/${to}`, filters)
      .then((response) => {
        dispatch({ type: SET_BARBER_FILTER, payload: response.barbersWithData });
        dispatch(setItems(response.transactions));
      });
  };

export const fetchRefundsBreakdownReport = (
  shopId,
  barberId,
  from,
  to,
  barberFilter,
  serviceCategories,
  productBrands,
  kind
) =>
  (dispatch) => {
    const filters = { barberId, barberFilter, serviceCategories, productBrands, type: kind };
    return Http.get(`/shop/${shopId}/report/refunded-breakdown/${from}/${to}`, filters)
      .then((response) => {
        dispatch({ type: SET_BARBER_FILTER, payload: response.barbersWithData });
        dispatch(setItems(response.transactions));
      });
  };
